var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[_c('Header',[_c('img',{staticStyle:{"width":"100px","height":"38px"},attrs:{"src":require("@/static/logo1.png"),"alt":""},on:{"click":function($event){return _vm.$router.push({name:'home'})}}})]),_c('div',{staticClass:"content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }